<template>
<main-content>
    <div class="bg-white p-3 rounded">
        <div>
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                    <router-link
                        :class="['nav-link', tab === 'gateway-form' ? 'active' : '']"
                        data-toggle="tab"
                        :to="`/gateways/update/${hashid}/gateway-form`"
                        role="tab"
                        :aria-selected="tab === 'gateway-form'"
                    >
                        {{ $t('label.gateway_form') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                        :class="['nav-link', tab === 'allowed-ips' ? 'active' : '']"
                        data-toggle="tab"
                        :to="`/gateways/update/${hashid}/allowed-ips`"
                        role="tab"
                        :aria-selected="tab === 'allowed-ips'"
                    >
                        {{ $t('label.gateway_allowed_ips') }}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link
                        :class="['nav-link', tab === 'switching-setting' ? 'active' : '']"
                        data-toggle="tab"
                        :to="`/gateways/update/${hashid}/switching-setting`"
                        role="tab"
                        :aria-selected="tab === 'switching-setting'"
                    >
                        تنظیمات سوئیچ
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div :class="['tab-pane', tab === 'gateway-form' ? 'active' : '']" id="gateway-form">
                <gateway-form v-if="status !== 'loading'" :form_data="form_data" :submit="submit"></gateway-form>
            </div>
            <div :class="['tab-pane', tab === 'allowed-ips' ? 'active' : '']" id="allowed-ips">
                <gateway-ips :ips="form_data.allowed_ips"></gateway-ips>
            </div>
            <div :class="['tab-pane', tab === 'switching-setting' ? 'active' : '']" id="switching-setting">
                <switching-setting-user v-if="hashid" :gateway_hashid="hashid"></switching-setting-user>
            </div>
        </div>
    </div>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import GatewayForm from './components/update-form'
import $ from 'jquery'
import { gatewayService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import GatewayIps from '@/views/gateway/components/gateway-ips.vue';
import SwitchingSettingUser from '@/views/gateway/components/SwitchingSettingUser.vue';
import { gatewayStatus } from '@/constants/gatewayStatus';

export default {
    components: {
        GatewayIps,
        SwitchingSettingUser,
        mainContent,
        GatewayForm,
    },
    computed: {
        ...mapGetters('gateway', [
            'form_data', 'status'
        ]),
        editTabs() {
            return ['gateway-form', 'allowed-ips', 'switching-setting'];
        },
        requestedTab() {
            return this.$route.params.tab || 'gateway-form';
        },
        tab() {
            return this.editTabs.includes(this.requestedTab) ? this.requestedTab : 'gateway-form';
        },
        hashid() {
            return this.$route.params.hashid;
        }
    },
    mounted() {
        this.loadGatewayData();
        this.ensureValidTab(this.$route.params.tab);
    },
    watch: {
        '$route.params.hashid'(newHashid, oldHashid) {
            if (newHashid && newHashid !== oldHashid) {
                this.loadGatewayData();
            }
        },
        '$route.params.tab'(newTab) {
            this.ensureValidTab(newTab);
        }
    },
    methods: {
        ensureValidTab(tab) {
            if (!tab || this.editTabs.includes(tab)) {
                return;
            }

            this.redirectToSettlement(tab);
        },
        redirectToSettlement(tab) {
            if (!this.hashid) {
                return;
            }

            this.$nextTick(() => {
                this.$router.replace(`/settlement-settings/ipg/${this.hashid}/${tab || ''}`);
            });
        },
        loadGatewayData() {
            if (!this.hashid) {
                return;
            }
            this.$store.dispatch('gateway/find', this.hashid)
                .catch(({response}) => {
                    throw new Error(response)
                })
        },
        submit(e) {
            let form = $('#gateway_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    merchant_share_percent: {
                        required: true
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            let params = { ...this.$store.getters['gateway/form_data'] }
            if (params && params.status === gatewayStatus.ACTIVE) {
                if (Object.prototype.hasOwnProperty.call(params, 'sheba')) {
                    delete params.sheba
                }
            }
            gatewayService.update(this.hashid, params).then(response => {
                this.$store.commit('gateway/clearFormData')
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            });
        }
    }
}
</script>

<style>
    .dropdown.bootstrap-select.disabled {
        border: 1px solid #e2e5ec;
        border-radius: 4px;
        background-color: #f7f8fa;
        opacity: 1;
        color: #495057;
    }
</style>